import React from 'react';
import NavigationBar from '../../../components/NavigationBar/NavigationBar';
import BrandButton from '../../../components/BrandButton/BrandButton';
import {
  isLocalizeAdded,
  LocalizePropType,
  UpsellingData,
} from 'getaway-data-layer';
import { GA_TITLES } from '../../../../utils';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import './UpsellingsView.less';
import TariffItem from '../../../components/TariffItem/TariffItem';
import UpsellingDialog from './UpsellingDialog/UpsellingDialog';

type props = {
  localize: LocalizePropType;
  upsellings: UpsellingData[];
  onClose: () => void;
  onSubmit: () => void;
  upsellingSelected: string;
  setUpsellingSelected: (code: string) => void;
  isBusiness: boolean;
  showUpsellingDialog: boolean;
  handleYesAction: () => void;
  handleNoAction: () => void;
  isUpsellingDialogEnabled: () => boolean;
};

const UpsellingsView = ({
  localize,
  upsellings,
  onClose,
  onSubmit,
  upsellingSelected,
  setUpsellingSelected,
  isBusiness,
  showUpsellingDialog,
  handleYesAction,
  handleNoAction,
  isUpsellingDialogEnabled,
}: props) => {
  return (
    <>
      {isUpsellingDialogEnabled() && showUpsellingDialog && (
        <UpsellingDialog
          localize={localize}
          showUpsellingDialog={showUpsellingDialog}
          handleYesAction={handleYesAction}
          handleNoAction={handleNoAction}
        />
      )}
      <div className="screen-container">
        <NavigationBar
          TitleTestId="UpsellingsView-title"
          DescriptionTestId="UpsellingsView-description"
          title={localize('upsellings.title')}
          description={localize('upsellings.header.desc')}
          showHelp
          onClose={onClose}
          showArrowBack
        />
        <div
          className={
            isLocalizeAdded(localize, 'upsellings.faq')
              ? 'screen-body-faq'
              : 'screen-body'
          }
        >
          <div
            className={
              isLocalizeAdded(localize, 'upsellings.faq')
                ? 'screen-body-content-faq'
                : 'screen-body-content'
            }
          >
            {upsellings?.length > 0 &&
              upsellings?.map((upselling, index) => (
                <TariffItem
                  tariffTestId="UpsellingsView-upsellingOption"
                  key={upselling.code}
                  firstItem={index === 0}
                  lastItem={index === upsellings?.length - 1}
                  localize={localize}
                  title={localize(`tariff.upselling.${upselling.code}.header`)}
                  subTitle={
                    isBusiness &&
                    isLocalizeAdded(
                      localize,
                      `tariff.upselling.business.${upselling.code}.title`
                    )
                      ? localize(
                          `tariff.upselling.business.${upselling.code}.title`
                        )
                      : localize(`tariff.upselling.${upselling.code}.title`)
                  }
                  price={localize(`tariff.upselling.${upselling.code}.price`)}
                  description={
                    upselling?.code === 'free'
                      ? null
                      : isLocalizeAdded(
                          localize,
                          `tariff.upselling.${upselling.code}.desc`
                        )
                      ? localize(`tariff.upselling.${upselling.code}.desc`)
                      : null
                  }
                  onClick={() => {
                    setUpsellingSelected(upselling.code);
                  }}
                  selected={upselling?.code === upsellingSelected}
                  subTitleClassName={upselling?.code === 'free' ? 'red' : ''}
                  showPopularBadge={isLocalizeAdded(
                    localize,
                    `tariff.upselling.${upselling.code?.replace(
                      /\s/g,
                      ''
                    )}.popular`
                  )}
                  popularText={localize(
                    `tariff.upselling.${upselling.code?.replace(
                      /\s/g,
                      ''
                    )}.popular`
                  )}
                />
              ))}
          </div>
          {isLocalizeAdded(localize, 'upsellings.faq') && (
            <div className="faq">
              <Markdown rehypePlugins={[rehypeRaw]}>
                {localize('upsellings.faq')}
              </Markdown>
            </div>
          )}
          <div style={{ height: 200 }} />
          <BrandButton
            id={GA_TITLES.ON_BOARDING.UPSELLING_SUBMITTED}
            title={localize('upsellings.button.text')}
            onClick={onSubmit}
            enableKeyboardEffect={false}
          />
        </div>
      </div>
    </>
  );
};

export default UpsellingsView;
